import Table from 'components/common/Table'
import React from 'react'

const SEARCH_OPTIONS = [
  // 'medium',
  'accountFullName',
  'accountEmail',
  'translatorFullName',
  'translatorEmail',
  'firstName',
  'lastName',
]
const ORDER_OPTIONS = [
  // 'medium',
  'translatorFullName',
  'translatorEmail',
  'firstName',
  'lastName',
  'createdAt',
  'endedAt',
]

const Calls = ({ title, endpoint, columnsToSkip }) => {
  return (
    <Table
      key={endpoint}
      paginated
      title={title}
      endpoint={endpoint}
      dataAccessor='calls'
      searchOptions={SEARCH_OPTIONS}
      orderOptions={ORDER_OPTIONS}
      columnsToSkip={columnsToSkip}
    />
  )
}

export default Calls
